module.exports = __webpack_public_path__ + "58a3353c07af0cbe17087e5388033254.png";